import React, { useState } from "react";
import { MdPhone } from "react-icons/md";
import styled, { keyframes, css } from "styled-components";
import { RiRobot2Line } from "react-icons/ri";
import { LuSendHorizontal, LuRefreshCw } from "react-icons/lu";

function BookingAgent() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [refreshRotating, setRefreshRotating] = useState(false);

  const handleRefresh = () => {
    setRefreshRotating(true);
    setInput("");
    setMessages([]);
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    // Add user message to chat
    setMessages([...messages, { from: "user", text: input }]);
    setInput("");
    setLoading(true);

    // Simulate API call with setTimeout
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "This is a dummy response." },
      ]);
      setLoading(false);
    }, 1500);
  };

  return (
    <>
      {/* <ChatPreview>
        <ChatWindow>
          <ChatHeader>
            <BotInfo>
              <RiRobot2Line fontSize={24} />
              <BotName>Chatbot</BotName>
            </BotInfo>
            <RefreshIcon> <RiRobot2Line fontSize={44} /></RefreshIcon>
          </ChatHeader>
          <ChatBody>
            <ChatMessage>
              ---- Chat application start here. ----
              <div
                style={{ padding: 10, display: "flex", justifyContent: "end" }}
              >
                <div
                  style={{
                    backgroundColor: "#7620ff",
                    color: "#fff",
                    padding: "4px 20px",
                    borderRadius: "10px",
                    letterSpacing: "1px",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p>message</p>
                </div>
              </div>
            </ChatMessage>
            <ChatInputContainer>
              <ChatInput
                id="text"
                name="text"
                type="text"
                placeholder="Write a text here..."
              />
              <SendButton>
                <LuSendHorizontal fontSize={18} />
              </SendButton>
            </ChatInputContainer>
          </ChatBody>
        </ChatWindow>
      </ChatPreview> */}
      <ChatPreview>
        <ChatWindow>
          <ChatHeader>
            <BotInfo>
              <RiRobot2Line fontSize={24} />
              <BotName>Chatbot</BotName>
            </BotInfo>
            <RefreshIcon
              onClick={handleRefresh}
              rotating={refreshRotating}
              onAnimationEnd={() => setRefreshRotating(false)}
            >
              <LuRefreshCw fontSize={22} />
            </RefreshIcon>
          </ChatHeader>
          <ChatBody>
            {messages.length === 0 && (
              <ChatMessage>---- Chat application start here. ----</ChatMessage>
            )}

            {messages.map((msg, idx) => (
              <ChatMessage
                key={idx}
                style={{ textAlign: msg.from === "user" ? "right" : "left" }}
              >
                <div
                  style={{
                    backgroundColor:
                      msg.from === "user" ? "#7620ff" : "#f3f4f6",
                    color: msg.from === "user" ? "#fff" : "#374151",
                    padding: "4px 20px",
                    borderRadius: "10px",
                    letterSpacing: "1px",
                    fontSize: "16px",
                    display: "inline-block",
                    margin: "4px 0",
                    maxWidth: "300px",
                    overflow: "hidden",
                  }}
                >
                  <p
                    style={{ overflowWrap: "break-word", whiteSpace: "normal" }}
                  >
                    {msg.text}
                  </p>
                </div>
              </ChatMessage>
            ))}

            {loading && (
              <ChatMessage style={{ textAlign: "left" }}>
                <div
                  style={{
                    backgroundColor: "#f3f4f6",
                    color: "#374151",
                    padding: "4px 20px",
                    borderRadius: "10px",
                    fontSize: "16px",
                    display: "inline-block",
                  }}
                >
                  <p>Loading...</p>
                </div>
              </ChatMessage>
            )}

            <ChatInputContainer>
              <ChatInput
                id="text"
                name="text"
                type="text"
                placeholder="Write a text here..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSend();
                }}
              />
              <SendButton onClick={handleSend} disabled={loading}>
                <LuSendHorizontal fontSize={18} />
              </SendButton>
            </ChatInputContainer>
          </ChatBody>
        </ChatWindow>
      </ChatPreview>
    </>
  );
}

const ChatPreview = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 450px;
`;

const ChatWindow = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const ChatHeader = styled.div`
  background-color: #7620ff;
  color: white;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const BotInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const BotName = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

// Keyframes for 360deg rotation
const rotate360 = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RefreshIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ rotating }) =>
    rotating &&
    css`
      animation: ${rotate360} 1s linear;
    `}
`;
const ChatBody = styled.div`
  padding: 1.5rem;
  min-height: 300px;
  display: flex;
  flex-direction: column;
`;

const ChatMessage = styled.div`
  text-align: center;
  color: #6b7280;
  margin-bottom: 10px;
`;

const ChatInputContainer = styled.div`
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  overflow: hidden;
  margin-top: auto;
`;

const ChatInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  outline: none;
  font-size: 0.875rem;
  color: #374151;

  &::placeholder {
    color: #9ca3af;
  }
`;

const SendButton = styled.button`
  background-color: #7620ff;
  color: white;
  border: none;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export default BookingAgent;
